module.exports = __webpack_public_path__ + "img/logo_texto_preto.d0e2d3d0.png";